import React, {Component, Fragment} from 'react';
import marketStyle from '../css/markets.css';
import OddsCard from './oddsCard';
import {getText} from "../../../../../helpers/localization";
import {betSlipAnimationCalculate} from "../../../../../helpers/helperFunctions";
import {generateFav, generateRandom, generateRandomBets, getMarketByCode} from "../helpers/marketHelpers";
import {addOpenBet, checkForQuickSelect, removeOpenBet} from "../../../actions/openBetsActions";
import {SINGLE} from "../../../../../constants/identifiers";
import {MATCHDAY_QUICK_FAV_TYPE, MATCHDAY_QUICK_RANDOM_TYPE} from "../constants/identifiers";
import {setSelectedMatchdayEventId} from "../../../../../actions/eventsActions";
import {getBonusPercentage, isTextBasedGame} from '../helpers/matchdayHelper';
import style from "../../../css/button.css";
import {ASSETS_URL} from "../../../../../constants/endpoints";

class BothTeamsScore extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isClicked: false,
            animationSourceRect: {
                top: 0,
                left: 0,
            },
        }
    }

    _openMoreBets(matchdayEventId) {
        this.props.store.dispatch(setSelectedMatchdayEventId(matchdayEventId, this.props.store));
    }

    _activeButton(eventRef, active) {
        if (active) {
            eventRef.target.classList.add(marketStyle.quickButton_active);
        } else {
            eventRef.target.classList.remove(marketStyle.quickButton_active);
        }
    }

    render() {
        let store = this.props.store;
        let matchdayMarkets = this.props.matchdayMarkets;
        let standardView = this.props.standardView;
        let channelName =  this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex].channel;
        let bothTeamToScoreMarkets = matchdayMarkets.map((eventMarket, index) => {
            if (standardView == undefined || standardView) {
                return (<div className={marketStyle.marketGroup} key={index}>
                    <div className={marketStyle.scoreGroupMedium}>
                        <div className={`${marketStyle.marketLabelMedium} ${marketStyle.marketLabel}`}>
                            <span>{getText('YES', this.props.store)}</span>
                        </div>
                        <div className={marketStyle.oddsContainerMedium}>
                            <OddsCard store={store} market={eventMarket.market[0]} event={eventMarket.event}/>
                        </div>
                    </div>
                    <div className={marketStyle.scoreGroupMedium}>
                        <div className={`${marketStyle.marketLabelMedium} ${marketStyle.marketLabel}`}>
                            <span>{getText('NO', this.props.store)}</span>
                        </div>
                        <div className={marketStyle.oddsContainerMedium}>
                            <OddsCard store={store} market={eventMarket.market[1]} event={eventMarket.event}/>
                        </div>
                    </div>
                </div>);
            } else {
                let teamNameStyle = this.props.isGreekMatchday ? marketStyle.teamNameGreek : marketStyle.teamName;
                return (<div className={marketStyle.marketGroup} key={index}>
                    <div className={marketStyle.headerColumn}>
                        <div className={marketStyle.marketTeam}>
                            <b className={marketStyle.headerPadding}>
                                {isTextBasedGame(channelName) ? 
                                    <span>
                                        {getText('Matchday_' + eventMarket.event.teamOne, this.props.store)} - {getText('Matchday_' + eventMarket.event.teamTwo, this.props.store)}
                                    </span>
                                :
                                    <span className={`${teamNameStyle}`} onClick={() => this._openMoreBets(eventMarket.event.eventId)}>
                                        {getText('Matchday_' + eventMarket.event.teamOne, this.props.store)} - {getText('Matchday_' + eventMarket.event.teamTwo, this.props.store)}
                                    </span>
                                }
                            </b>
                        </div>
                    </div>
                    <div className={marketStyle.headerColumnMedium}>
                        <OddsCard store={store} market={eventMarket.market[0]} event={eventMarket.event}/>
                    </div>
                    <div className={marketStyle.headerColumnMedium}>
                        <OddsCard store={store} market={eventMarket.market[1]} event={eventMarket.event}/>
                    </div>
                        { !isTextBasedGame(channelName) &&
                            <div className={marketStyle.headerColumnMoreMarkets}>
                                <div className={marketStyle.customButtonContainer}>
                                    <span className={marketStyle.morebetsButton}
                                         onClick={() => this._openMoreBets(eventMarket.event.eventId)}><span>+6</span></span>
                                </div>
                            </div>
                        }
                </div>);
            }
        });
        let advancedView = '';
        if (standardView != undefined && !standardView) {
            advancedView = (!isTextBasedGame(channelName)) ? (<Fragment>
                <div className={marketStyle.header}>
                    <div className={marketStyle.scrollRef} ref={this.props.scrollRef}></div>
                    <span className={`${marketStyle.headerColumn} ${marketStyle.btts}`}>
                <b className={marketStyle.headerPadding}>{getText('BOTH_TEAMS_SCORE', this.props.store)}</b>
                <b className={marketStyle.headerPadding}>{getText('BOTH_TEAMS_SCORE_INITIALS', this.props.store)}</b>
            </span>
                    <span className={marketStyle.headerColumnMedium}>{getText('YES', this.props.store)}</span>
                    <span className={marketStyle.headerColumnMedium}>{getText('NO', this.props.store)}</span>
                    <span className={marketStyle.headerColumnMoreMarkets}/>
                </div>
                <div className={`${marketStyle.marketGroup} ${marketStyle.marketGroupHeader} `} key={'QuickSelect'}>
                    <div className={marketStyle.headerColumn}>
                        <div className={marketStyle.marketTeam}>
                            <b className={marketStyle.headerPadding}>{getText('QUICK_SELECT', this.props.store)}</b>
                        </div>
                    </div>
                    <div className={marketStyle.headerColumnMedium}>
                        <div className={marketStyle.customButtonContainer}>
                            <div className={marketStyle.quickButton} id={'8_random_btts'}
                                 onTouchStart={(evt) => this._activeButton(evt, true)}
                                 onTouchEnd={(evt) => this._activeButton(evt, false)}
                                 onClick={() => this._placeRandom('8_random_btts')}>{this._getQuickButtonText('8RANDOM', this.props.store)}
                                {this.state.isClicked && (<div className={`${style.betSlipAnimation}`} style={{
                                    top: `${this.state.animationSourceRect.top}px`,
                                    left: `${(this.state.animationSourceRect.left)}px`
                                }}>
                                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`}
                                         width="35" height="35"/>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    <div className={marketStyle.headerColumnMedium}>
                        <div className={marketStyle.customButtonContainer}>
                            <div className={marketStyle.quickButton} id={'8_favs_btts'}
                                 onTouchStart={(evt) => this._activeButton(evt, true)}
                                 onTouchEnd={(evt) => this._activeButton(evt, false)}
                                 onClick={() => this._placeFavs('8_favs_btts')}>{this._getQuickButtonText('8FAVS', this.props.store)}
                                {this.state.isClicked && (<div className={`${style.betSlipAnimation}`} style={{
                                    top: `${this.state.animationSourceRect.top}px`,
                                    left: `${(this.state.animationSourceRect.left)}px`
                                }}>
                                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`}
                                         width="35" height="35"/>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    <div className={marketStyle.headerColumnMoreMarkets}/>
                </div>
            </Fragment>) :
            (<Fragment>
                <div className={marketStyle.header}>
                    <div className={marketStyle.scrollRef} ref={this.props.scrollRef}></div>
                    <span className={`${marketStyle.headerColumn} ${marketStyle.btts}`}>
                <b className={marketStyle.headerPadding}>{getText('BOTH_TEAMS_SCORE', this.props.store)}</b>
                <b className={marketStyle.headerPadding}>{getText('BOTH_TEAMS_SCORE_INITIALS', this.props.store)}</b>
            </span>
                    <span className={marketStyle.headerColumnMedium}>{getText('YES', this.props.store)}</span>
                    <span className={marketStyle.headerColumnMedium}>{getText('NO', this.props.store)}</span>
                </div>
                <div className={`${marketStyle.marketGroup} ${marketStyle.marketGroupHeader} `} key={'QuickSelect'}>
                    <div className={marketStyle.headerColumn}>
                        <div className={marketStyle.marketTeam}>
                            <b className={marketStyle.headerPadding}>{getText('QUICK_SELECT', this.props.store)}</b>
                        </div>
                    </div>
                    <div className={marketStyle.headerColumnMedium}>
                        <div className={marketStyle.customButtonContainer}>
                            <div className={marketStyle.quickButton} id={'4_random_btts'}
                                 onTouchStart={(evt) => this._activeButton(evt, true)}
                                 onTouchEnd={(evt) => this._activeButton(evt, false)}
                                 onClick={() => this._placeRandomBets('4_random_btts',4)}>{this._getQuickButtonText('4RANDOM', this.props.store, 4)}
                                {this.state.isClicked && (<div className={`${style.betSlipAnimation}`} style={{
                                    top: `${this.state.animationSourceRect.top}px`,
                                    left: `${(this.state.animationSourceRect.left)}px`
                                }}>
                                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`}
                                         width="35" height="35"/>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    <div className={marketStyle.headerColumnMedium}>
                        <div className={marketStyle.customButtonContainer}>
                            <div className={marketStyle.quickButton} id={'6_random_btts'}
                                 onTouchStart={(evt) => this._activeButton(evt, true)}
                                 onTouchEnd={(evt) => this._activeButton(evt, false)}
                                 onClick={() => this._placeRandomBets('6_random_btts',6)}>{this._getQuickButtonText('6RANDOM', this.props.store, 6)}
                                {this.state.isClicked && (<div className={`${style.betSlipAnimation}`} style={{
                                    top: `${this.state.animationSourceRect.top}px`,
                                    left: `${(this.state.animationSourceRect.left)}px`
                                }}>
                                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`}
                                         width="35" height="35"/>
                                </div>)}
                            </div>
                        </div>
                    </div>
                    <div className={marketStyle.headerColumnMedium}>
                        <div className={marketStyle.customButtonContainer}>
                            <div className={marketStyle.quickButton} id={'8_random_btts'}
                                 onTouchStart={(evt) => this._activeButton(evt, true)}
                                 onTouchEnd={(evt) => this._activeButton(evt, false)}
                                 onClick={() => this._placeRandomBets('8_random_btts',8)}>{this._getQuickButtonText('8RANDOM', this.props.store, 8)}
                                {this.state.isClicked && (<div className={`${style.betSlipAnimation}`} style={{
                                    top: `${this.state.animationSourceRect.top}px`,
                                    left: `${(this.state.animationSourceRect.left)}px`
                                }}>
                                    <img id='bet_slip_animation_image' src={`${ASSETS_URL}systemIcons/betslip.svg`}
                                         width="35" height="35"/>
                                </div>)}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>);
        }

        return (
            <div>
                {advancedView}
                {bothTeamToScoreMarkets}
            </div>
        );
    }

    _placeRandom(id) {
        let betType = getMarketByCode(this.props.matchdayMarkets[0].market[0].code);
        let random = generateRandom(this.props.matchdayMarkets, 1, 2);
        let openBetListLength = this.props.store.getState().vpp.openBetsList.length;
        if (checkForQuickSelect(betType, random, this.props.store.getState().vpp.openBetsSimpleList)) {
            this.props.store.getState().vpp.openBetsList.forEach((bet,index) => {
                let isLastBet = openBetListLength - 1 === index ? true : false;
                if (bet.bets.length == 1 && bet.bets[0].betType.code === betType.code && random.some(betRandom => betRandom.event.eventId == bet.bets[0].event.eventId && betRandom.event.channel == bet.bets[0].event.channel)) {
                    this.props.store.dispatch(removeOpenBet(bet,isLastBet));
                }
            });
            random.forEach(randomMarket => {
                let bet = {
                    game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
                    event: randomMarket.event,
                    betType: betType,
                    market: randomMarket.market,
                    type: SINGLE,
                    selectionType: MATCHDAY_QUICK_RANDOM_TYPE,
                    multiplier: 1
                };
                this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsSimpleList));
            })
        }
        this._updateStateForAnimation(id);
    }

    _placeRandomBets(id,betsize) {
        let betType = getMarketByCode(this.props.matchdayMarkets[0].market[0].code);
        let random = generateRandomBets(this.props.matchdayMarkets, 1, 2, betsize);
        let openBetListLength = this.props.store.getState().vpp.openBetsList.length;
        if (checkForQuickSelect(betType, random, this.props.store.getState().vpp.openBetsSimpleList, 
            isTextBasedGame(this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex].channel))) {
            this.props.store.getState().vpp.openBetsList.forEach((bet,index) => {
                let isLastBet = openBetListLength - 1 === index ? true : false;
                if (bet.bets.length == 1 && bet.bets[0].event.leagueDay === random[0].event.leagueDay && random.some(betRandom => betRandom.event.channel == bet.bets[0].event.channel)) {
                    this.props.store.dispatch(removeOpenBet(bet,isLastBet));
                }
            });
            random.forEach(randomMarket => {
                let bet = {
                    game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
                    event: randomMarket.event,
                    betType: betType,
                    market: randomMarket.market,
                    type: SINGLE,
                    selectionType: MATCHDAY_QUICK_RANDOM_TYPE,
                    multiplier: 1
                };
                this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsSimpleList));
            })
        }
        this._updateStateForAnimation(id);
    }

    _updateStateForAnimation(id) {
        let sourceRectValues = betSlipAnimationCalculate(false, document.getElementById(id));
        clearTimeout(this.handle);

        // IF logic for reclicks in 1 second by turning off current animation and start a new one. ELSE logic for normal flow.
        if (this.state.isClicked) {
            this._toggleClickHandler(false);
            setTimeout(() => this._toggleClickHandler(true, sourceRectValues), 10);
        } else {
            this._toggleClickHandler(true, sourceRectValues);
        }
        this.handle = setTimeout(() => this._toggleClickHandler(false), 1000);
    }

    _toggleClickHandler(isClicked, sourceRectValues) {
        if (isClicked) {
            this.setState({
                ...this.state,
                isClicked: true,
                animationSourceRect: {
                    top: sourceRectValues.sourceTop,
                    left: sourceRectValues.sourceLeft,
                }
            })
        } else {
            this.setState({
                ...this.state,
                isClicked: false
            })
        }
    }

    _placeFavs(id) {
        let betType = getMarketByCode(this.props.matchdayMarkets[0].market[0].code);
        let favs = generateFav(this.props.matchdayMarkets);
        let openBetListLength = this.props.store.getState().vpp.openBetsList.length;
        if (checkForQuickSelect(betType, favs, this.props.store.getState().vpp.openBetsSimpleList)) {
            this.props.store.getState().vpp.openBetsList.forEach((bet,index) => {
                let isLastBet = openBetListLength - 1 === index ? true : false;
                if (bet.bets.length == 1 && bet.bets[0].betType.code === betType.code && favs.some(betFav => betFav.event.eventId == bet.bets[0].event.eventId && betFav.event.channel == bet.bets[0].event.channel)) {
                    this.props.store.dispatch(removeOpenBet(bet,isLastBet));
                }
            });

            favs.forEach(favMarket => {
                let bet = {
                    game: this.props.store.getState().vpp.games[this.props.store.getState().vpp.selectedGameIndex],
                    event: favMarket.event,
                    betType: betType,
                    market: favMarket.market,
                    type: SINGLE,
                    selectionType: MATCHDAY_QUICK_FAV_TYPE,
                    multiplier: 1
                };
                this.props.store.dispatch(addOpenBet(bet, this.props.store.getState().vpp.openBetsSimpleList));
            })
        }
        this._updateStateForAnimation(id);
    }

    _getQuickButtonText(buttonKey, store, key) {

        let bonusPercentage = getBonusPercentage(store, key);
        let quickButtonText = bonusPercentage === null ? <Fragment>{getText(buttonKey, store)}</Fragment> :
            <div className={marketStyle.quickButtonParent}>
                <div className={marketStyle.quickButtonText}>{getText(buttonKey, store)}</div>
                <div className={marketStyle.quickButtonBonus}>{bonusPercentage}</div>
            </div>;
        return quickButtonText;

    }
}

export default BothTeamsScore;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/bothTeamsScore.js